import { render, staticRenderFns } from "./requirement-edit.vue?vue&type=template&id=274ce4b6&scoped=true&"
import script from "./requirement-edit.vue?vue&type=script&lang=js&"
export * from "./requirement-edit.vue?vue&type=script&lang=js&"
import style0 from "./requirement-edit.vue?vue&type=style&index=0&id=274ce4b6&lang=less&scoped=true&"
import style1 from "./requirement-edit.vue?vue&type=style&index=1&id=274ce4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ce4b6",
  null
  
)

export default component.exports